import '../App.css';
import { useNavigate } from 'react-router-dom';

import UserRegister from '../model/request/UserRegister';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import OccupationDropdown from './Occupation';
import EducationDropdown from './Education';
import TopBar from './TopBar';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import RegisterResponseData from '../model/response/RegistrationResponse';
import { ToastContainer, toast } from "react-toastify";
import logo from '../images/logo.jpeg';
import Offeradd from './Offeradd.js';

function Qualification() {
  var location = useLocation();
  var { userRegister: userObject, isFromRegistration } = location.state || {};
  const navigation = useNavigate()
  var userObject = userObject;


  var [education, seteducation] = useState("");
  var [educationError, seteducationError] = useState();

  var [employed, setemployed] = useState("");
  var [employedError, setemployedError] = useState();

  var [occupation, setoccupation] = useState("");
  var [occupationError, setoccupationError] = useState();
  var [income, setincome] = useState("");
  var [incomeError, setincomeError] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (userObject == null) {
      navigation('/');
    }
  }, [userObject, navigation]);
  if (!userObject) {
    return null; // render nothing briefly
  }


  var userObject = Object.setPrototypeOf(userObject, UserRegister.prototype);
  function clicktoVerifyscreen() {
    if (validation()) {
      setIsSubmitting(true);
      userObject.highest_Education = parseInt(education);
      userObject.employed_In = parseInt(employed);
      if (employed === "6") {
        userObject.occupation = 140;
        userObject.annual_Income = 28;
      } else {
        userObject.occupation = parseInt(occupation);
        userObject.annual_Income = parseInt(income);
      }

      ProfileAPICall();
    }

  }

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }


  function ProfileAPICall() {
    console.log("Response:", JSON.stringify(userObject));
    axios.post(
      ApiConfig.getUrl("User/registration"),
      JSON.stringify(userObject),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {
        console.log("Response:", response.data.response.statusCode);
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.response);
        if (api.statusCode == 200) {

          const register = RegisterResponseData.fromJson(api.response);
          console.log("statusCode:", register.userId);

          console.log("REGISTER RESPONSE:", register);
          console.log("REGISTER DOB:", register.dateOfBirth);
          if (register.dateOfBirth) {
            localStorage.setItem(
              "user_dob",
              register.dateOfBirth
            );
          }
          showToast("OTP sent your Mobile Number Successfully!.");
          setTimeout(() => {
            navigation('/Verify', { state: { userId: register.userId, isFromRegistration: true } })
          }, 2000);


        } else {
          setIsSubmitting(false);
          showToastFailed(api.errorMessage);
        }

      })
      .catch(error => {
        setIsSubmitting(false);
        console.error("Error:", error);
      });
  }
  function validation() {
    var isFlage = true;


    if (education === "") {
      seteducationError("Select Your Education.");
      isFlage = false;
    } else {
      seteducationError("");
    }


    if (employed === "") {
      setemployedError("Select Your Employed.");
      isFlage = false;
    } else {
      setemployedError("");
    }


    if (employed !== "6") {

      if (occupation === "") {
        setoccupationError("Select Your Occupation.");
        isFlage = false;
      } else {
        setoccupationError("");
      }

      if (income === "") {
        setincomeError("Select Your Income.");
        isFlage = false;
      } else {
        setincomeError("");
      }

    } else {

      setoccupationError("");
      setincomeError("");
    }

    return isFlage;
  }

  const disableRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <ToastContainer />
      <div className='fullview' onContextMenu={disableRightClick}>
        <TopBar />
        <div className='container mt-4'>
          <div className='row mt-5 align-items-center gx-0'>
            <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
              <img className='image h-100 w-100' src={logo} alt='logo' />
            </div>

            <div className="col-lg-6 col-12  card p-2">
              <p className="h5 text-center mt-2 pt-2">Qualification</p>

              {/* <p> <label htmlFor="education" className="education" >Highest Education </label></p> */}
              <EducationDropdown onChange={(val) => seteducation(val)} />
              <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{educationError}</span>

              {/* <label htmlFor="employed" className="employed"  >Employed in </label> */}
              <select
                id="employed"
                className="form-control mt-2"
                value={employed}
                onChange={(e) => {
                  const value = e.target.value;
                  setemployed(value);

                  // Not Working selected
                  if (value === "6") {
                    setoccupation("");
                    setincome("");
                  }
                }}
              >
                <option value="">Select your Employment</option>
                <option value="1">Government/PSU</option>
                <option value="2">Defence</option>
                <option value="3">Private</option>
                <option value="4">Business</option>
                <option value="5">Self Employed</option>
                <option value="6">Not Working</option>
              </select>

              <span
                className="mt-2 text-danger text-decoration-none"
                style={{ letterSpacing: "1px" }}
              >
                {employedError}
              </span>


              {/* Occupation + Salary - hide when Not Working */}
              {employed !== "6" && (
                <>
                  <OccupationDropdown
                    value={occupation}
                    onChange={(val) => setoccupation(val)}
                  />

                  <span
                    className="mt-2 text-danger text-decoration-none"
                    style={{ letterSpacing: "1px" }}
                  >
                    {occupationError}
                  </span>


                  <select
                    id="income"
                    className="form-control mt-2"
                    value={income}
                    onChange={(e) => setincome(e.target.value)}
                  >
                    <option value="">Select Your Annual Income</option>
                    <option value="1">0 - 1 Lakh</option>
                    <option value="2">1 - 2 Lakh</option>
                    <option value="3">2 - 3 Lakhs</option>
                    <option value="4">3 - 4 Lakhs</option>
                    <option value="5">4 - 5 Lakhs</option>
                    <option value="6">5 - 6 Lakhs</option>
                    <option value="7">6 - 7 Lakhs</option>
                    <option value="8">7 - 8 Lakhs</option>
                    <option value="9">8 - 9 Lakhs</option>
                    <option value="10">9 - 10 Lakhs</option>
                    <option value="11">10 - 12 Lakhs</option>
                    <option value="12">12 - 14 Lakhs</option>
                    <option value="13">14 - 16 Lakhs</option>
                    <option value="14">16 - 18 Lakhs</option>
                    <option value="15">18 - 20 Lakhs</option>
                    <option value="16">20 - 25 Lakhs</option>
                    <option value="17">25 - 30 Lakhs</option>
                    <option value="18">30 - 35 Lakhs</option>
                    <option value="19">35 - 40 Lakhs</option>
                    <option value="20">40 - 45 Lakhs</option>
                    <option value="21">45 - 50 Lakhs</option>
                    <option value="22">50 to 60 Lakhs</option>
                    <option value="23">60 - 70 Lakhs</option>
                    <option value="24">70 - 80 Lakhs</option>
                    <option value="25">80 - 90 Lakhs</option>
                    <option value="26">90 Lakhs - 1 Crore</option>
                    <option value="27">1 Crore & Above</option>
                    <option value="28">0 - 0 Lakh</option>
                  </select>

                  <span
                    className="mt-2 text-danger text-decoration-none"
                    style={{ letterSpacing: "1px" }}
                  >
                    {incomeError}
                  </span>
                </>
              )}


              <button onClick={clicktoVerifyscreen} type="button" className="btn w-100 mt-3 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }} disabled={isSubmitting}>Next page</button>


            </div>
          </div>
          <Offeradd />
        </div>

      </div>
      <footer className='bg-dark text-white text-center'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>
  );
}
export default Qualification;
